import type React from 'react';
import { useRef } from 'react';
import type { AnimatedSvgRef } from './types';

export function useDefaultHoverBehavior(ref?: React.Ref<AnimatedSvgRef>) {
  const internalRef = useRef<AnimatedSvgRef>(null);
  const actualRef = ref || internalRef;

  const handleMouseEnter = () => {
    if (typeof actualRef === 'function') {
      return;
    }
    actualRef?.current?.runAnimationForward();
  };

  const handleMouseLeave = () => {
    if (typeof actualRef === 'function') {
      return;
    }
    actualRef?.current?.runAnimationBackward();
  };

  return {
    actualRef,
    ...(!ref && {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
    }),
  };
}
